<template>
  <div v-if="schema" class="ai-voice-write-button">
    <vs-button class="w-full" color="primary" type="border" @click="showPopup = true">
      <div class="flex items-center justify-center">
        <feather-icon icon="MicIcon" svgClasses="w-4 h-4" />
        <span class="ml-2">{{ $t("AI 음성 작성") }}</span>
      </div>
    </vs-button>

    <popup-ai-voice-write v-if="mountedPopup" v-model="showPopup" :board-id="boardId" :schema="schema" :form="form" @apply="onApply" />
  </div>
</template>

<script>
import PopupAiVoiceWrite from "@/popup/PopupAiVoiceWrite.vue";

export default {
  name: "AiVoiceWriteButton",
  components: { PopupAiVoiceWrite },
  props: {
    boardId: [String, Number],
    // 게시판 폴더의 ai-voice-schema.js
    schema: { type: Object, default: null },
    // 현재 작성 중인 폼(form.body)
    form: { type: Object, required: true },
  },
  data() {
    return {
      showPopup: false,
      // 팝업은 처음 열 때 생성한다(마이크/오디오 리소스를 미리 잡지 않도록).
      mountedPopup: false,
    };
  },
  watch: {
    showPopup(active) {
      if (active) this.mountedPopup = true;
    },
  },
  methods: {
    onApply(nextForm) {
      this.$emit("apply", nextForm);
    },
  },
};
</script>
